


















































import { Component, Vue, Prop } from "vue-property-decorator";
import { CompanyResponse, InsuranceCard } from "@/services/index.defs";
import { CalcState } from "@/models/Models";
import CardIcon from "./CardIcon.vue";
import { GaHelper } from "@/core/helpers/ga";
import { isSameDay } from "date-fns/fp";
import { EventName, sendPostMessageEvent } from '@/utils/analyticMessages';

@Component({ components: { CardIcon } })
export default class IssueSuccess extends Vue {
    @Prop(Boolean) other; // shown on IssueOther success=true screen
    get issue(): CalcState {
        return this.$store.direct.state.iccalc.issue;
    }

    get isIcRecalcPrice() {
        return this.$store.state.iccalc?.currentCalc?.amount !== this.issue?.amount;
    }

    isSafari = false;
    created() {
        this.sendStats();
        this.isSafari =
            /iPad|iPhone|iPod/.test(navigator.platform) ||
            (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    }

    sendStats() {
        const changes = this.changes;
        if (changes.length == 0) {
            GaHelper.send("issue/selected");
        } else {
            GaHelper.send("issue/selectedChanged");
        }
    }
    get changes() {
        let changes = [];
        let sameDay =
            isSameDay(
                this.currentCalc.beginDate?.parseDate(),
                this.card.beginDate.parseDate()
            ) &&
            isSameDay(
                this.issue.beginDate.parseDate(),
                this.card.beginDate.parseDate()
            );
        if (!sameDay) {
            changes.push("startdate");
        }
        if (this.currentCalc.amount != this.issue?.amount) {
            changes.push("price");
        }
        if (this.issue.month != this.card.insuranceMonth) {
            changes.push("period");
        }
        return changes;
    }

    get currentCalc(): CalcState {
        return this.$store.state.iccalc.currentCalc;
    }
    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }

    get loading() {
        return this.$store.direct.state.insurance.isLoading;
    }
    set loading(v) {
        this.$store.direct.commit.insurance.toggleLoading(v);
    }
    collectStats() {
        sendPostMessageEvent(EventName.PayPolicy, this.currentCalc.insuranceProviderId);
        try {
            GaHelper.send("paylink");
        } catch {
            console.error("analytics failed...");
        }
    }

    async openPaymentScreen() {
        this.loading = true;
        if (this.issue.payLink) {
            try {
                await this.$store.direct.dispatch.insurance.saveIssue({
                    icName: this.issue.insuranceProviderId,
                    cardId: this.card.id
                });
            } finally {
                this.collectStats();
                if (window.self !== window.top) {
                    // Код внутри iframe
                    window.parent.postMessage({
                        call: 'goToLink',
                        link: this.issue.payLink,
                    }, '*');
                } else {
                    if ((this.$root as any).br.mdAndUp && !this.isSafari)
                        // обходим ограничения для сафари на открытие окон
                        window.open(this.issue.payLink, "_blank");
                    else location.href = this.issue.payLink;
                }
                setTimeout(() => (this.loading = false), 10000); // cant listen to events of cross-origin window
            }
        }
    }

    get provider(): CompanyResponse {
        return this.$store.direct.state.dicti.providers.find(
            x =>
                x.code ==
                this.$store.direct.state.iccalc.currentCalc.insuranceProviderId
        );
    }
}
